import * as React from 'react'

import { Tag } from '@factorialco/deprecated-design-system'
import {
  AmountStrategyTagFragment,
  ContractsValueObjectsAmountStrategyTypeEnum,
} from 'generated/resources/graphql'

import { fromCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import { isGraphQLType } from 'modules/contracts/lib/types'
import { UsePayrollConceptCompensationUnits } from 'modules/payroll_bundle/hooks/usePayrollConceptCompensationUnits'

type Props = {
  amountStrategyType: ContractsValueObjectsAmountStrategyTypeEnum
  amountStrategy: AmountStrategyTagFragment
  unit: UsePayrollConceptCompensationUnits
}

function formatMinutes(minutes: number): string {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  if (hours > 0 && mins > 0) {
    return `${hours}h ${mins}m`
  } else if (hours > 0) {
    return `${hours}h`
  } else {
    return `${mins}m`
  }
}

function formatAmount(amount: number, unit: UsePayrollConceptCompensationUnits): string {
  if (unit === 'EUR') {
    return String(fromCents(amount))
  } else if (unit === 'mins') {
    return formatMinutes(amount)
  }

  return String(amount)
}

function AmountStrategyTag({ amountStrategyType, amountStrategy, unit }: Props) {
  let text = ''

  if (
    amountStrategyType === 'contracts_fixed_amount_strategy' &&
    isGraphQLType(amountStrategy, 'ContractsFixedAmountStrategy')
  ) {
    const prefix = i18n.t(
      'contract_versions.additional_compensation.amount_strategy_tag.fixed_amount_strategy'
    )

    if (amountStrategy.amount != null) {
      const formattedAmount = formatAmount(amountStrategy.amount, unit)

      if (unit === 'mins') {
        text = `${prefix} - ${formattedAmount}`
      } else {
        text = `${prefix} - ${formattedAmount} ${unit}`
      }
    } else {
      text = prefix
    }
  } else if (
    amountStrategyType === 'contracts_variable_amount_strategy' &&
    isGraphQLType(amountStrategy, 'ContractsVariableAmountStrategy')
  ) {
    const prefix = i18n.t(
      'contract_versions.additional_compensation.amount_strategy_tag.variable_amount_strategy'
    )

    if (amountStrategy.upperLimit != null) {
      const upToText = i18n.t('contract_versions.additional_compensation.amount_strategy_tag.up_to')
      const formattedAmount = formatAmount(amountStrategy.upperLimit, unit)

      if (unit === 'mins') {
        text = `${prefix} - ${upToText} ${formattedAmount}`
      } else {
        text = `${prefix} - ${upToText} ${formattedAmount} ${unit}`
      }
    } else {
      text = `${prefix} - ${i18n.t(
        'contract_versions.additional_compensation.amount_strategy_tag.no_limit'
      )}`
    }
  }

  return (
    <Tag type="neutral" inline leftItem="circle">
      {text}
    </Tag>
  )
}

export { AmountStrategyTag }
